import { useTalkFlowShareList } from '@/hooks/apiHooks';
import { RecordFilter, ShareMode } from '@/types/api';
import { useAtomValue } from 'jotai';
import { MyInfoState } from '@/recoil/atom';
import { useFormContext } from 'react-hook-form';
import { roleToFilter } from '@/components/Record/util/function';

//@ref: Ai 관련된 상태 및 결과 조회는 useAiSummaries 이용해주세요
const useAi = () => {
  const { getValues } = useFormContext<RecordFilter>();

  const { passportId } = useAtomValue(MyInfoState);
  const isOwner = getValues('createdBy')?.passportId === passportId;

  const { data: shareData } = useTalkFlowShareList(getValues('docId'));

  const sharerList = (shareData?.data ?? [])
    .filter((res) => roleToFilter(res.role) === ShareMode.Share)
    .map((res) => res.scope.value);

  const isSharer = sharerList.find((res) => res === passportId);

  return {
    isOwner,
    canModify: Boolean(isSharer || isOwner),
  };
};

export default useAi;
